import { CategoryGridCard } from "@/features/shop";
import { cn } from "@/shared/utils/style.util";
import type { LucideIcon } from "lucide-react";

export type CategoryItem = {
  key: string
  title: string
  icon: LucideIcon
  backgroundColor: string
  textColor: string
  link: string
};

export type CategoryGridProps = { categories: CategoryItem[] };

const HIDDEN_BELOW_3XL_KEYS = new Set(["partenaires"]);

export const CategoryGrid = ({ categories }: CategoryGridProps) => {
  return (
    <div className="flex w-full flex-nowrap gap-2 py-1 sm:gap-3">
      {categories.map((category) => (
        <div
          key={category.key}
          className={cn(
            "min-w-0 flex-1",
            HIDDEN_BELOW_3XL_KEYS.has(category.key) && "hidden 3xl:block",
          )}
        >
          <CategoryGridCard
            icon={category.icon}
            title={category.title}
            backgroundColor={category.backgroundColor}
            textColor={category.textColor}
            link={category.link}
          />
        </div>
      ))}
    </div>
  );
};
